export { default } from "./Information";
